import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api, setAuth, clearAuth, getUser } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(getUser());
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const t = localStorage.getItem("hn_token");
    if (!t) { setReady(true); return; }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("hn_user", JSON.stringify(r.data)); })
      .catch(() => clearAuth())
      .finally(() => setReady(true));
  }, []);

  const value = useMemo(() => {
    const login = async (email, password) => {
      const { data } = await api.post("/auth/login", { email, password });
      setAuth(data.token, data.user); setUser(data.user);
      return data.user;
    };
    const signup = async (payload) => {
      const { data } = await api.post("/auth/signup", payload);
      setAuth(data.token, data.user); setUser(data.user);
      return data.user;
    };
    const logout = () => { clearAuth(); setUser(null); };
    return { user, setUser, login, signup, logout, ready };
  }, [user, ready]);

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}
